import React, { useState, useEffect, Suspense } from "react";
import { connect } from "react-redux";

import { Modal, Button, Spinner, Row, Col } from "react-bootstrap";

import { storeContact } from "../../../actions/scanActions";
import FormLoader from "../../loader/FormLoader";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import swal from 'sweetalert';
import { getUrl, setUserData } from "../../../utills/defaultValues";
import SuccessModal from "./SuccessModal";

const ReportModal = ({ show, handleClose, lastId, source, websiteURL, storeContact, contactDetails }) => {

  const initialValues = {
    lastid: "",
    name: "",
    email: "",
    mobile: "",
    designation: "",
    website: websiteURL,
    company_name: "",
    country: "",
    btn_flag: "",
    user_id: "",
  }

  const [userId, setUserId] = useState(() => {
    return localStorage.getItem("userKey") || null;
  });
  const [modalData, setModalData] = useState({ header: "", content: "" });
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const message = "Check out this awesome website to see vulnerabilities in your website!";
  const currentUrl = window.location.origin;

  useEffect(() => {
    if (!userId) {
      const newUserId = generateUserId();
      localStorage.setItem("userKey", newUserId);
      setUserId(newUserId);
    }
  }, [userId]);

  useEffect(() => {
    if (getUrl() !== null) {
      if (contactDetails.status === true) {
          handleClose();
        if (source === "awesome") {
          setModalData({ header: "Thank you!", content: contactDetails?.message, status: "success" })
          handleSuccessModal()
          // swal("", contactDetails?.message, "success").then(function () {
          //   window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(`${message} ${currentUrl}`)}`, "_blank");
          // });
        } else if (source === "fix-wish") {
          setModalData({ header: "Thank you!", content: "Our team will contact you soon!", status: "success" })
          handleSuccessModal()
          // swal("Thank you!", "Our team will contact you soon!", "success");
        }
        else if (source === "report") {
          setModalData({ header: "Thank you!", content: "Your scan report is coming via email!", status: "success" })
          handleSuccessModal()
          // swal("Thank you!", "Your scan report is coming via email!", "success");
        }
      }
      else if (contactDetails.status === false) {
        setModalData({ header: "Please try again!", content: "Something went wrong.", status: "error" })
        handleSuccessModal()
      }
    }
  }, [contactDetails])

  const generateUserId = () => {
    return `user_${Math.random().toString(36).substr(2, 9)}`;
  };

  const handleSubmit = (formData, setSubmitting, resetForm) => {
    formData.lastid = lastId;
    formData.user_id = userId;
    formData.btn_flag = source;

    setUserData(formData)

    storeContact(formData, setSubmitting, resetForm)
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validationSchema = Yup.object().shape({
    website: Yup.string()
      .url('Invalid URL format')
      .required('Website Url is required'),
    name: Yup.string()
      .required("Name is required"),
    email: Yup.string()
      .lowercase()
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Enter a valid email address"
      )
      .required("Email is required")
      .nullable(true),
    mobile: Yup.string()
      .required("Please enter your mobile number")
      .matches(phoneRegExp, "Mobile number is not valid")
      .min(10, "Please enter 10 digit mobile number")
      .max(10, "Mobile Number should not exceed 10 digits"),
  });

  const handleSuccessModal = () => {
    setShowSuccessModal(true)
  }

  const handleFunction = () => {
    if (source === "awesome") {
      window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(`${message} ${currentUrl}`)}`, "_blank")
      setShowSuccessModal(false)
    }
    else {
      setShowSuccessModal(false)
    }
  }

  return (
    <div className="report-modal">
      <Modal
        show={show}
        onHide={handleClose}
        size="md"
        centered
      >
        <Modal.Header className="modal-header-custom">
          <Modal.Title className="report-modal-title">
            {source === "report" ? "Get your report" :
              source === "awesome" ? "Extend the invitation - share your info to refer your friends!" : "Drop your contact info here"
            }
          </Modal.Title>
          <button type="button" className="close-btn" onClick={handleClose}>
            &times;
          </button>
        </Modal.Header>

        <Modal.Body className="report-modal-body">
          <Row className="justify-content-center">
            <Col md="10" className="mx-auto my-auto">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(formData, { setSubmitting, resetForm }) => {
                  handleSubmit(formData, setSubmitting, resetForm);
                }}
              >
                {({ errors, touched, isSubmitting, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom contact-form">
                    <div className="space-for-error text-left">
                      <label className="form-group has-float-label mb-0">
                        <span>
                          {" "}
                          Name{" "}<span style={{ color: "#dc3545", fontSize: "15px" }}>*</span>
                        </span>
                      </label>
                      <Field
                        className="form-control"
                        name="name"
                      />
                      <span className="error-message">
                        {errors.name && touched.name
                          ? errors.name
                          : null}
                      </span>
                    </div>
                    <div className="space-for-error text-left">
                      <label className="form-group has-float-label mb-0">
                        <span>
                          {" "}
                          Email{" "}<span style={{ color: "#dc3545", fontSize: "15px" }}>*</span>
                        </span>
                      </label>
                      <Field
                        className="form-control"
                        name="email"
                      />
                      <span className="error-message">
                        {errors.email && touched.email
                          ? errors.email
                          : null}
                      </span>
                    </div>
                    <div className="space-for-error text-left">
                      <label className="form-group has-float-label mb-0">
                        <span>
                          {" "}
                          Mobile{" "}<span style={{ color: "#dc3545", fontSize: "15px" }}>*</span>
                        </span>
                      </label>
                      <Field
                        className="form-control"
                        name="mobile"
                      />
                      <span className="error-message">
                        {errors.mobile && touched.mobile
                          ? errors.mobile
                          : null}
                      </span>
                    </div>
                    <div className="space-for-error text-left">
                      <label className="form-group has-float-label mb-0">
                        <span>
                          {" "}
                          Website{" "}<span style={{ color: "#dc3545", fontSize: "15px" }}>*</span>
                        </span>
                      </label>
                      <Field
                        className="form-control"
                        name="website"
                      />
                      <span className="error-message">
                        {errors.website && touched.website
                          ? errors.website
                          : null}
                      </span>
                    </div>
                    <div className="space-for-error text-left">
                      <label className="form-group has-float-label mb-0">
                        <span>
                          {" "}
                          Company Name
                        </span>
                      </label>
                      <Field
                        className="form-control"
                        name="company_name"
                      />
                    </div>
                    <div className="space-for-error text-left">
                      <label className="form-group has-float-label mb-0">
                        <span>
                          {" "}
                          Designation
                        </span>
                      </label>
                      <Field
                        className="form-control"
                        name="designation"
                      />
                      <span className="error-message">
                        {errors.designation && touched.designation
                          ? errors.designation
                          : null}
                      </span>
                    </div>
                    <div className="space-for-error text-left">
                      <label className="form-group has-float-label mb-0">
                        <span>
                          {" "}
                          Country
                        </span>
                      </label>
                      <Field
                        className="form-control"
                        name="country"
                      />
                    </div>

                    <div className="d-flex justify-content-center align-items-center">
                      <Button
                        type="submit"
                        className="btn-shadow vs-button-css"
                        size="md"
                      >
                        {isSubmitting ? (
                          <>
                            <FormLoader />
                            <span style={{ marginLeft: "8px" }}>Please wait..</span>
                          </>
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Suspense>
        <SuccessModal
          show={showSuccessModal}
          modalData={modalData}
          handleClose={() => setShowSuccessModal(false)}
          performFunction={handleFunction}
        />
      </Suspense>
    </div>
  );
};

// Map state to props
const mapStateToProps = (state) => ({
  contactDetails: state.scan.contactDetails,
});

export default connect(mapStateToProps, { storeContact })(ReportModal);
